<script lang="ts">
  import Icon from './icon.svelte';

  /**
   * The rounded, filled square an icon sits in at the top of a card.
   *
   * Three sizes were in use — 16/12/10 — with the icon inside scaled by hand
   * to 7, 6 or 5, and the pairing got it wrong in a couple of places. Tying
   * the icon size to the tile size means that cannot drift.
   *
   * `tone` is the fill: `brand` and `action` for solid tiles, `brand-soft`
   * and `action-soft` for the tinted ones whose icon carries the colour
   * instead. The deleted `.icon-container-*` classes in `app.css` were an
   * earlier attempt at this that nothing ever called.
   */
  let {
    name,
    tone = 'brand',
    size = 'md',
    shape = 'rounded-xl',
    family = 'outline'
  }: {
    name: string;
    tone?: 'brand' | 'action' | 'brand-soft' | 'action-soft';
    size?: 'lg' | 'md' | 'sm';
    shape?: string;
    family?: 'outline' | 'solid';
  } = $props();

  const box = $derived({ lg: 'h-16 w-16', md: 'h-12 w-12', sm: 'h-10 w-10' }[size] ?? 'h-12 w-12');
  const glyph = $derived({ lg: 'h-7 w-7', md: 'h-6 w-6', sm: 'h-5 w-5' }[size] ?? 'h-6 w-6');
  const fill = $derived(
    {
      brand: 'bg-brand text-ink-inverse',
      action: 'bg-action text-ink-inverse',
      'brand-soft': 'bg-brand-soft text-brand',
      'action-soft': 'bg-action-soft text-action-text'
    }[tone] ?? 'bg-brand text-ink-inverse'
  );
</script>

<div class="flex {box} items-center justify-center {shape} {fill}">
  <Icon {name} {family} size={glyph} />
</div>
